import { render, staticRenderFns } from "./infoproposal.vue?vue&type=template&id=183377b4&scoped=true&"
import script from "./infoproposal.vue?vue&type=script&lang=js&"
export * from "./infoproposal.vue?vue&type=script&lang=js&"
import style0 from "./infoproposal.vue?vue&type=style&index=0&id=183377b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183377b4",
  null
  
)

export default component.exports